import React, { useState, useEffect } from "react"
import logoPS from '../assets/images/logo-ps-202x2.svg'
import logoVote from '../assets/images/vote-for-your-weekend.svg'
import burger from '../assets/images/burger.svg'
import close from '../assets/images/close.svg'
import { Link } from "react-router-dom"
import { useRouteMatch, generatePath } from "react-router"
import Literal from "../literals/Literal"
import GridContainer from './GridContainer'

const Header = ({ showLogo }) => {
  const [open, setOpen] = useState(false)
  const match = useRouteMatch()
  const [currentLanguage, setCurrentLanguage] = useState(match.params.lang || 'en')
  
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'initial'
    }
  }, [open])

  useEffect(() => {
    setCurrentLanguage(match.params.lang || 'en')
    setOpen(false)
  }, [match])

  const generateLangUrl = (newLang) => {
    const url = generatePath(match.path, {
      lang: newLang,
      groupId: match.params.groupId,
      groupName: match.params.groupName,
    })
    return url
  }

  const generateUrl = (path) => {
    const lang = match.params.lang || 'en'
    return `/${lang}/${path || ''}`
  }

  return (
    <div className="relative">
    {/* burger menu open - start */}
      {open && <div
        className={`md:hidden absolute mobile-menu flex flex-col items-center z-10`}
        style={{
          opacity: open ? 1 : 0,
          transition: `opacity 0.3s`,
          height: "100vh",
          width: '100vw',
        }}
      >
        <div className="flex flex-row items-center justify-between w-full px-4 py-6">
        <div className="fixed top-0 left-0 spot-gradient" />
          <div className="w-2/6">
            <img src={logoPS} alt="Primavera Sound 202X2!" className="w-full"/>
          </div>
          <div className="absolute right-0 p-6 mr-1 cursor-pointer " onClick={() => setOpen(!open)}>
            <img src={close} alt="" className="h-4"/>
          </div>
        </div>
        <GridContainer>
          <div className="flex flex-col col-span-4 sm:col-start-2 sm:col-span-2">
            <div className="self-center w-full max-w-md px-12 py-6 sm:px-4 md:hidden">
              <img src={logoVote} alt="VOTE YOUR WEEKEND" className="w-full"/>
            </div>
            <div className="flex flex-col items-center mt-12 text-5xl font-secondary">
              <Link to={generateUrl()} className="mb-4">{Literal('NAV_HOME')}</Link>
              <Link to={generateUrl('about')}  className="mb-4">{Literal('NAV_ABOUT')}</Link>
              <div className="flex flex-row items-center justify-between">
                <Link className={`${currentLanguage && currentLanguage === 'en' ? 'underline' : ''} mr-4`} to={generateLangUrl('en')}>EN</Link>
                <Link className={`${currentLanguage && currentLanguage === 'es' ? 'underline' : ''}`} to={generateLangUrl('es')}>ES</Link>
              </div>
            </div>
          </div>
        </GridContainer>
      </div>}
      {/* burger menu open - end */}

      <div className="flex flex-row items-center justify-between w-full px-4 py-6 md:px-10 md:py-12">
        <div className="w-2/6 md:w-40 lg:w-48">
          <Link className="w-full" to={generateUrl()}>
            <img src={logoPS} alt="Primavera Sound 202X2!" className="w-full"/>
          </Link>
          <div className="flex-row items-center justify-start hidden mt-2 text-lg font-sharpSemiBold13 md:flex">
            <Link
              className={`mr-3 ${currentLanguage && currentLanguage === 'en' ? 'underline' : ''}`}
              to={generateLangUrl('en')}
            >EN</Link>
            <Link
              className={`${currentLanguage && currentLanguage === 'es' ? 'underline' : ''}`}
              to={generateLangUrl('es')}
            >ES</Link>
          </div>
        </div>
        {showLogo && <div className="hidden w-2/5 md:block md:w-36 lg:w-40">
          <img src={logoVote} alt="VOTE YOUR WEEKEND" className="w-full"/>
        </div>}
        <div className="flex-col hidden md:text-lg lg:text-xl md:flex font-secondary">
          <Link to={generateUrl()}>{Literal('NAV_HOME')}</Link>
          <Link to={generateUrl('about')} >{Literal('NAV_ABOUT')}</Link>
        </div>
        <div className="absolute right-0 p-6 cursor-pointer md:hidden" onClick={() => setOpen(!open)}>
          <img src={burger} alt="" className="h-4"/>
        </div>
      </div>
    </div>
  )
}

export default Header